import Vue from 'vue'
import parseJsonWithBigInt from 'utils/parseJsonWithBigInt'

/**
 * 获取开户进度
 * @param {string} params.type 客户类型 [individual | individual_us | stl | ria_us] FIXME:美国版本固定写死
 * @param {string} params.customer_id 客户资料编号
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchCustomerAccountProcessInfo(params) {
  return Vue.http
    .get('~customer/api/v1/individual/account/process', {
      params
    })
    .then(({ data }) => {
      if (data.is_succ) {
        return data.data
      }
      throw data
    })
}
/**
 * 获取客户的账户信息
 * @param {string} params.type 客户类型 [individual | individual_us | stl | ria_us] FIXME:美国版本固定写死
 * @param {string} params.customer_id 客户资料编号
 * @param {string} params.account_id 账户ID
 * @param {string} params.account_type 账户类型 ib | bs | virtual
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchCustomerAccountInfo(params) {
  return Vue.http
    .get('~customer/api/v1/individual/account/info', { params })
    .then(res => {
      if (res.data.is_succ) return res.data.data
      throw res.data
    })
}
/**
 * 获取聊天的 json web token 信息
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchChatJWT() {
  return Vue.http.get('~customerSupport/api/v1/chat/jwt')
}
/**
 * 开通模拟盘
 * @param {number} template_id - 模拟盘ID（美国版固定10000）
 * @returns {PromiseLike<HttpResponse>}
 */
export function openVirtualAccount(template_id = 10000) {
  return Vue.http
    .post(
      '~customer/virtual/api/v1/virtual/account',
      { template_id },
      { emulateJSON: true }
    )
    .then(res => {
      if (res.data.is_succ) return res.data.data
      throw res.data.data
    })
}

/**
 * 获取模拟盘信息
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchVirtualAccounts() {
  return Vue.http
    .get('~customer/virtual/api/v1/virtual/accounts')
    .then(response => {
      if (response) {
        const res = parseJsonWithBigInt(response.bodyText)
        if (res.is_succ) return res.data
        throw res.data
      } else {
        throw response
      }
    })
}

/**
 * 获取开户下拉列表信息
 * @param {string} field - 区域名称[https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20618658]
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchCustomerAccountField(field) {
  return Vue.http.get(`~customer/api/v1/account/field/${field}`)
}
